<template>
  <div class="pickerContainer">
    <div class="inputWrapper" :style="{ backgroundColor: selectedColor }">
      <input
        type="text"
        v-model="selectedColor"
        class="colorInput"
        @input="emitColorChange"
        @click="openColorPicker"
        readonly
      />
    </div>
    <button class="colorPickerButton" type="button" @click="openColorPicker">
      <BrushIcon />
    </button>
    <input
      ref="colorInput"
      type="color"
      v-model="selectedColor"
      class="hiddenColorInput"
      @input="emitColorChange"
    />
  </div>
</template>

<script>
import { ref } from 'vue'
import { Brush as BrushIcon } from 'lucide-vue'

export default {
  name: "ColorPicker",
  components: {
    BrushIcon
  },
  props: {
    defaultValue: {
      type: String,
      default: "#0694e5",
    },
  },
  emits: ["change"],
  setup(props, { emit }) {
    const selectedColor = ref(props.defaultValue)
    const colorInput = ref(null)

    const emitColorChange = () => {
      emit("change", selectedColor.value)
    }

    const openColorPicker = () => {
      colorInput.value.click()
    }

    const resetColor = () => {
      selectedColor.value = props.defaultValue
      emitColorChange()
    }

    return {
      selectedColor,
      colorInput,
      emitColorChange,
      openColorPicker,
      resetColor
    }
  },
  mounted() {
    this.resetColor()
  },
}
</script>

<style scoped>
.pickerContainer {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.inputWrapper {
  flex-grow: 1;
  position: relative;
  height: 40px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out, box-shadow 0.3s ease-in-out;
}

.inputWrapper:hover {
  transform: scale(1.01);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

.colorInput {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 20px;
  background: transparent;
  color: transparent;
  text-shadow: none;
  cursor: pointer;
}

.colorInput:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
}

.colorPickerButton {
  background: none;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #555;
}

.colorPickerButton:hover {
  transform: scale(1.1);
  opacity: 0.8;
}

.hiddenColorInput {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
</style>
